import { initialState } from "./salaryCalculationTaxFigures";

//add inputs here, import totalyeargross and fixed cost here
const SalaryCalculationYear2Reducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_SURPLUS_BEFORE_TAX_YEAR_2":
      return { ...state, surplus: action.payload };
    case "GET_TEMPLATE_PAYROLL_TAX_YEAR_2":
      return { ...state, templatePayroll: action.payload };
    case "GET_TEMPLATE_PAYROLL_PERCENT_YEAR_2":
      return { ...state, templatePayrollPercent: action.payload };
    case "GET_FIXED_EARNED_INCOME_YEAR_2":
      return { ...state, fixedEarnedIncome: action.payload };
    case "GET_STANDARD_TAX_RELIEF_YEAR_2":
      return { ...state, standardTaxRelief: action.payload };
    case "GET_TAXABLE_INCOME_YEAR_2":
      return { ...state, taxableIncome: action.payload };
    case "GET_LOCAL_TAXES_YEAR_2":
      return { ...state, localTaxes: action.payload };
    case "GET_LOCAL_TAXES_PERCENT_YEAR_2":
      return { ...state, localTaxesPercent: action.payload };
    case "GET_STATE_TAX_YEAR_2":
      return { ...state, stateTax: action.payload };
    case "GET_STATE_TAX_CUT_OF_VALUE_YEAR_2":
      return { ...state, stateTaxCutOfValue: action.payload };
    case "GET_STATE_TAX_PERCENT_YEAR_2":
      return { ...state, stateTaxPercent: action.payload };
    case "GET_PAYROLL_TAX_YEAR_2":
      return { ...state, payrollTax: action.payload };
    case "GET_PAYROLL_TAX_PERCENT_YEAR_2":
      return { ...state, payrollTaxPercent: action.payload };
    case "GET_GENERAL_PENSION_YEAR_2":
      return { ...state, generalPension: action.payload };
    case "GET_GENERAL_PENSION_CUT_OFF_VALUE_YEAR_2":
      return { ...state, generalPensionCutOffValue: action.payload };
    case "GET_GENERAL_PENSION_PERCENT_YEAR_2":
      return { ...state, generalPensionPercent: action.payload };
    case "GET_FUNERAL_FEES_YEAR_2":
      return { ...state, funeralFees: action.payload };
    case "GET_FUNERAL_FEES_PERCENT_YEAR_2":
      return { ...state, funeralFeesPercent: action.payload };
    case "GET_REDUCTION_OF_GENERAL_PENSION_YEAR_2":
      return { ...state, reductionOfGeneralPension: action.payload };
    case "GET_EARNED_INCOME_TAX_YEAR_2":
      return { ...state, earnedIncomeTax: action.payload };
    case "GET_EARNED_INCOME_TAX_CUT_OFF_VALUE_YEAR_2":
      return { ...state, earnedIncomeTaxCutOffValue: action.payload };
    case "GET_EARNED_INCOME_TAX_PERCENT_YEAR_2":
      return { ...state, earnedIncomeTaxPercent: action.payload };
      case "GET_NET_PROFIT_PER_YEAR_YEAR_2":
      return { ...state, netProfitPerYear: action.payload };
    case "GET_NET_PROFIT_PER_MONTH_YEAR_2":
      return { ...state, netProfitPerMonth: action.payload };
    case "GET_GENERAL_PAYROLL_TAX_YEAR_2":
      return { ...state, generalPayrollTax: action.payload };
    case "GET_GENERAL_PAYROLL_TAX_PERCENT_YEAR_2":
      return { ...state, generalPayrollTaxPercent: action.payload };
    case "GET_GROSS_ANNUAL_SALARY_YEAR_2":
      return { ...state, grossAnnualSalary: action.payload };
    case "GET_NON_TAXABLE_INCOME_LIMIT_YEAR_2":
      return { ...state, nonTaxableIncomeLimit: action.payload };
    default:
      return state;
  }
};

export default SalaryCalculationYear2Reducer;
